import React, { useContext } from "react";
import ChatGlobalContext from "../context/ChatGlobalContext";
import { Row } from 'react-bootstrap';
import { navigate } from 'gatsby';
import Container from "./Container";
import icoYouFibre from '../assets/images/favicon.svg';
import icoCloseChat from '../assets/images/ico-close.png';
import Header from "./styled/Header";
import { initialTwilioChatState } from "../utils/chats";

const ChatHeader = ({...props}) => {
    const gContext: any = useContext(ChatGlobalContext);
    return (
        <Header>
          <Container className='justify-between'>
            <Row className='p-0 m-0 align-items-center'>
              <a href="https://www.youfibre.com/" className="p-0 m-0">
                <img src={icoYouFibre} onClick={() => window.location.href = 'https://www.youfibre.com/'}/>
                <span>&nbsp;YouFibre</span>
              </a>
            </Row>            
            <Row className='p-0 m-0 align-items-center'>
              { !gContext?.goGetTwilioChat()?.chatConversationId && gContext?.goGetTwilioChat()?.chatUserType && <button onClick={() => gContext?.goSetTwilioChat({...gContext?.goGetTwilioChat(), ...initialTwilioChatState, fullscreen: gContext?.goGetTwilioChat()?.fullscreen, side: gContext?.goGetTwilioChat()?.side, openChat: true})} className='small'>Back</button> }
              { gContext?.goGetTwilioChat()?.chatConversationId && <button onClick={() => gContext?.goGetTwilioChat()?.chatCaseId && gContext?.goSetTwilioChat({...gContext?.goGetTwilioChat(), confirmClosing: true, chatClosingType: 'CUSTOMER'})} className='small'>End conversation</button> }
              { !props?.fullScreen && <img src={icoCloseChat} className='close' onClick={() => gContext?.goSetTwilioChat({...gContext?.goGetTwilioChat(), openChat: !gContext?.goGetTwilioChat()?.openChat}) } />}
            </Row>          
          </Container>
        </Header>
    );
};

export default ChatHeader;